// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1lUYT","bigColWidth":"Table_bigColWidth__1nSfx","biggerColWidth":"Table_biggerColWidth__2odV4","row":"Table_row__2K5yg","col":"Table_col__2LENv"};